import React, { FC, memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetProjectsQuery } from '../../api/projectsApi';
import Icon from '../../components/Icon/Icon';
import Tooltip from '../../components/Tooltip/Tooltip';
import { IconColorE, IconSizeE, ProjectStatusE, StatusColorE, StatusE } from '../../models/enums';
import { ProjectT } from '../../models/models';
import { statusFilters } from '../../utils/helpers/statusFilters';
import { useTranslate } from '../../utils/hooks/useTranslate';

import styles from './styles.module.scss';

type DeliveryShortT = {
    Id: number;
    Number: number;
    Status: number;
};

type DeliveryNumbersListPropTypes = {
    deliveries: DeliveryShortT[];
}

const MAX_DELIVERIES_COUNT = 6;

const DeliveryNumbersList: FC<DeliveryNumbersListPropTypes> = memo((props) => {
    const { deliveries } = props;
    const navigate = useNavigate();
    const { t } = useTranslate();

    const navigateToProjectPage = (e, number: number) => {
        e.preventDefault();
        navigate(`/deliveries/${number}`);
    };

    const statuses = Object.entries(ProjectStatusE);

    return (
        <ul className={styles.deliveryNumbersList}>
            {deliveries.slice().sort((a, b) => +b.Number - +a.Number).slice(0, MAX_DELIVERIES_COUNT).map((delivery: DeliveryShortT) => (
                <li
                    key={delivery.Id}
                    style={{ backgroundColor: StatusColorE[statuses.find(entry => +entry[0] === +delivery.Status)?.[1]], color: '#fff' }}
                >
                    <a href={`/deliveries/${delivery.Id}`} onClick={(e) => navigateToProjectPage(e, delivery.Id)} className={styles.link}>
                        <Tooltip text={t(statusFilters.find(entry => entry.value === statuses[delivery.Status]?.[1])?.label)}>
                            {delivery.Number}
                        </Tooltip>
                    </a>
                </li>
            ))}
            {deliveries.length > MAX_DELIVERIES_COUNT && (
                <li className={styles.more}>
                    + {deliveries.length - MAX_DELIVERIES_COUNT}
                </li>
            )}{!deliveries?.length && (
                <li className={styles.more}>
                    {/* no deliveries */}
                </li>
            )}
        </ul>
    )
}, (prevProps, nextProps) => prevProps.deliveries.length === nextProps.deliveries.length);

export default DeliveryNumbersList;